let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7e4Nm")).then(() => parcelRequire('3GY0W'));